import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { BackOfficeInvoiceConfig } from './BackOfficeInvoiceConfig';

export class BackofficeProispraksiConfig extends BackOfficeInvoiceConfig {
    _originalTypeClassName = "zERP.BO.BackofficeProispraksiConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackofficeProispraksiConfig.translate = translateService;
}
super();
this.TransactionEntityPerLawyer = false;
this.IssueInvoiceForThird = false;
this.IssueInvoiceByThird = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
TransactionEntityPerLawyer:any;
IssueInvoiceForThird:any;
IssueInvoiceByThird:any;
AccountForCredit:any;
InvoiceTypeForThird:any;
SeriesForThird:any;
InvoiceTypeByThird:any;
SeriesByThird:any;
ERPTax:any;
BankAccount:any;
static setAccountForCredit = ($this, value) => {
var oldValue = $this.AccountForCredit;
$this.AccountForCredit = value;
if (value != null) {
}
}
static setInvoiceTypeForThird = ($this, value) => {
var oldValue = $this.InvoiceTypeForThird;
$this.InvoiceTypeForThird = value;
if (value != null) {
}
}
static setSeriesForThird = ($this, value) => {
var oldValue = $this.SeriesForThird;
$this.SeriesForThird = value;
if (value != null) {
}
}
static setInvoiceTypeByThird = ($this, value) => {
var oldValue = $this.InvoiceTypeByThird;
$this.InvoiceTypeByThird = value;
if (value != null) {
}
}
static setSeriesByThird = ($this, value) => {
var oldValue = $this.SeriesByThird;
$this.SeriesByThird = value;
if (value != null) {
}
}
static setERPTax = ($this, value) => {
var oldValue = $this.ERPTax;
$this.ERPTax = value;
if (value != null) {
}
}
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}